import { DamageState } from '../../Profile/types/riskProfileSelected.types'
import type { RiskSelection, RiskSelectionPatch } from '../types/riskSelection.types'

const PARAM_KEYS = {
  workspaceId: 'workspace',
  areaGroup: 'areaGroup',
  areas: 'areas',
  hazardGroups: 'hazardGroups',
  elementGroups: 'elementGroups',
  damageStates: 'damageStates',
} as const

const parseArrayParam = (params: URLSearchParams, key: string): string[] => {
  const value = params.get(key)
  return value !== null && value !== '' ? value.split(',') : []
}

export function parseRiskSelection(params: URLSearchParams): RiskSelection {
  return {
    workspaceId: params.get(PARAM_KEYS.workspaceId),
    areaGroup: params.get(PARAM_KEYS.areaGroup),
    areas: parseArrayParam(params, PARAM_KEYS.areas),
    hazardGroups: parseArrayParam(params, PARAM_KEYS.hazardGroups),
    elementGroups: parseArrayParam(params, PARAM_KEYS.elementGroups),
    damageStates: parseArrayParam(params, PARAM_KEYS.damageStates) as DamageState[],
  }
}
/**
 * Returns a NEW URLSearchParams with the patch applied — never mutates
 * the params passed in, so callers can safely diff before/after in tests.
 */
export function applyRiskSelectionPatch(
  params: URLSearchParams,
  patch: RiskSelectionPatch,
): URLSearchParams {
  const next = new URLSearchParams(params)

  for (const [key, value] of Object.entries(patch)) {
    const paramKey = PARAM_KEYS[key as keyof typeof PARAM_KEYS]
    if (!paramKey) continue

    next.delete(paramKey)

    if (value == null) continue

    if (Array.isArray(value)) {
      if (value.length > 0) next.set(paramKey, value.join(','))
    } else {
      next.set(paramKey, String(value))
    }
  }

  return next
}
